// 拖动div元素
import Vue from 'vue';

Vue.directive('drag', {
  bind(el, bindings) {
    //el.querySelector('.drag').style.cursor = 'move';
    el.onmousedown = function(e){

      let disx = e.pageX - el.offsetLeft;
      let disy = e.pageY - el.offsetTop;

      document.onmousemove = function (e){
        //console.log(e);
        //console.log("----------拖拽-----------");//e.path[1].clientWidth,clientHeight
        if(0 <= (e.pageX - disx) && (e.pageX - disx) <= (1917-e.path[1].clientWidth) && 0 <= (e.pageY - disy) && (e.pageY - disy) <= (935-e.path[1].clientHeight)){
          el.style.left = e.pageX - disx+'px';
          el.style.top = e.pageY - disy+'px';
          //console.log(el.style.left);
          //console.log(el.style.top);
        }

      }
      document.onmouseup = function(){
        document.onmousemove = document.onmouseup = null;
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives.js